import { useTranslation } from 'react-i18next';
import { useLogger, useUserContext } from '@vp/ubik-context';
import { App } from '../app';
import { sanitiseLocale } from '../app/i18n/config';
import LogomakerGenAiPage from '../app/pages/LogomakerGenAiPage';
import LogomakerGenAiPagePhase1 from '../app/pages/LogomakerGenAiPagePhase1';
import { DefaultPageTrackingParams } from '../app/utils/analytics';
import type { Logger } from '@vp/ubik-logging';
import type { Translation } from '../@types/resources';
import type { EnvironmentContextType } from '../app/utils/environmentContext';

export interface Props {
    translation: Translation;
    envContext: EnvironmentContextType;
}

const defaultPageTrackingParams: DefaultPageTrackingParams = {
    route: '/logomaker',
};

export const Fragment = ({ translation, envContext }: Props) => {
    const logger: Logger = useLogger();
    const { i18n } = useTranslation();
    const locale = sanitiseLocale(useUserContext().locale);
    const userContext = useUserContext();

    const isPhase2Enabled =
        userContext.featureFlags?.vista_logos_logomaker_genai_landing_page_phase_2 === 'true';

    logger.info(`Rendering Logomaker gen ai fragment for the locale ${locale}`);

    i18n.addResourceBundle(locale, 'translation', translation).changeLanguage(locale);

    return (
        <App
            defaultPageTrackingParams={defaultPageTrackingParams}
            locale={locale}
            envContext={envContext}
        >
            {isPhase2Enabled ? <LogomakerGenAiPage /> : <LogomakerGenAiPagePhase1 />}
        </App>
    );
};
